import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Vendor, type VendorConstructor } from './Vendor'
import { VendorTypes } from '../enums/VendorTypeEnum'

export const VendorConstructorFactory =
  Factory.Sync.makeFactory<VendorConstructor>({
    id: Factory.each(() => faker.random.number()),
    externalId: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
    active: true,
    address: {
      addressLineOne: faker.address.streetAddress(),
      addressLineTwo: faker.address.secondaryAddress(),
      postalCode: faker.address.zipCode(),
      city: faker.address.city(),
      stateProvince: faker.address.state(),
      country: faker.address.country(),
    },
    contactInfo: {
      phoneOne: faker.phone.phoneNumber(),
      phoneTwo: faker.phone.phoneNumber(),
      fax: faker.phone.phoneNumber(),
      email: [faker.internet.email()],
      contact: faker.name.findName(),
      url: faker.internet.url(),
      emailConfigurations: null,
    },
    comments: Factory.each(() => faker.lorem.sentence()),
    dateModified: Factory.each(() => faker.date.past().toISOString()),
    paymentTerm: null,
    shippingTerm: null,
    shippingMethod: null,
    taxId: null,
    legalName: null,
    companyEmail: null,
    companyPhone: null,
    taxIdMasked: '••••6789',
    taxIdType: 'us_ein',
    taxIdTypeLabel: null,
    taxCountry: 'US',
    taxDocuments: Factory.each(() => [
      {
        id: faker.random.uuid(),
        docType: 'w9',
        originalFilename: 'w9-form.pdf',
        uploadedAt: faker.date.past().toISOString(),
      },
    ]),
    taxIdProvided: true,
    taxDocumentUploaded: true,
    type: VendorTypes.OTHER,
    pdfLabelSet: '',
    isAutoEmailPoEnabled: false,
    request: null,
  })

export const VendorFactory = EntityFactory(Vendor, VendorConstructorFactory)
